module.exports = __webpack_public_path__ + "img/tile_two.8e1fd740.png";